import React from 'react';
import StudentExperiences from '../student/StudentExperiences';

// Renders the Student & Parent VR Experiences experience as-is within the Coaching
// profile. Header + Footer switch automatically based on the /coaching/* prefix.
export default function CoachingVRExperiences() {
  return <StudentExperiences />;
}
